export const byProductFeatureCacheKey = (_state, product, feature) =>
  `${product || 'unknown'}-${feature || 'unknown'}`
